/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useState } from 'react'
// import React, { useState } from 'react'
import NavbarCommon from '../components/NavbarCommon'
import { Button, Card, Input, Typography } from '@material-tailwind/react'
import { DataContext } from '../context/DataProvider'

function Register() {

  const [input, setInput] = useState({
    name : "",
    image_url : "",
    email : "",
    password : "",
  })

  const handleChange = (e) => {
    let value = e.target.value
    let name = e.target.name

    setInput({...input, [name] : value})
  }

const { register } = useContext(DataContext)
 
  const handleRegis = async (e) => {
    e.preventDefault();

    try {
      console.log(input)

      const userRegister = await register (input.name, input.image_url, input.email, input.password)
      console.log(userRegister)
    } catch (error){
      console.error('Register failed:', error.message);
    }

  }



  return (
    <>
      <div className=''>
      <NavbarCommon />
      <div className='w-96 mx-auto my-12'>
      <Card color="transparent" shadow={false}>
        <Typography variant="h4" color="blue-gray">
          Sign Up
        </Typography>
        <Typography color="gray" className="mt-1 font-normal">
        Enter your details to register.
      </Typography>

      <form className="mt-8 mb-2 w-80 max-w-screen-lg sm:w-96">
        <div className="mb-1 flex flex-col gap-6">
          <Typography variant="h6" color="blue-gray" className="-mb-3">
            Your Name
          </Typography>
          <Input
          onChange={handleChange}
            value={input.name}
            name='name'
            type="text"
            size="lg"
            placeholder="name@mail.com"
            className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
            labelProps={{
              className: "before:content-none after:content-none",
            }}
          />
          <Typography variant="h6" color="blue-gray" className="-mb-3">
            Your Image (url)
          </Typography>
          <Input
          onChange={handleChange}
                        value={input.image_url}
                        name='image_url'
                        type="text"
            size="lg"
            placeholder="http://"
            className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
            labelProps={{
              className: "before:content-none after:content-none",
            }}
          />
          <Typography variant="h6" color="blue-gray" className="-mb-3">
            Your Email
          </Typography>
          <Input
          onChange={handleChange}
                        value={input.email}
                        name='email'
                        type="email"
            size="lg"
            placeholder="name@mail.com"
            className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
            labelProps={{
              className: "before:content-none after:content-none",
            }}
          />
          <Typography variant="h6" color="blue-gray" className="-mb-3">
            Password
          </Typography>
          <Input
          onChange={handleChange}
                      value={input.password}
                      name='password'
                        type="password"
            size="lg"
            placeholder="********"
            className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
            labelProps={{
              className: "before:content-none after:content-none",
            }}
          />
        </div>
        
        <Button className="mt-6" fullWidth onClick={handleRegis}>
          sign up
        </Button>
        <Typography color="gray" className="mt-4 text-center font-normal">
          Already have an account?{" "}
          <a href="#" className="font-medium text-gray-900">
            Sign In
          </a>
        </Typography>
      </form>
      
      </Card>
      </div>
      </div>
    </>
  )
}

export default Register